import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { LandingPage } from '../views/landing';
import { OnboardingPage } from '../views/onboarding';
import { ThankYouPage } from '../views/thank-you';
import LoginPage from '../views/auth/LoginPage';
import AdminOnboardingsPage from '../views/admin/AdminOnboardingsPage';
import AdminUsersPage from '../views/admin/AdminUsersPage';
import AdminXUsersPage from '../views/admin/AdminXUsersPage';
import AdminCategoriesPage from '../views/admin/AdminCategoriesPage';
import AppLayout from './AppLayout';
import DashboardPage from './DashboardPage';
import ProtectedRoute from './ProtectedRoute';
import { APP_PATHS } from '../routes/paths';
import { HTTP_CONFIG } from '../constants/http';

export default function AppContent() {
  return (
    <>
      <Routes>
        {/* Landing Page - Public */}
        <Route path="/" element={<LandingPage />} />

        {/* Onboarding - Public */}
        <Route path={APP_PATHS.onboarding} element={<OnboardingPage />} />

        {/* Thank You - Public */}
        <Route path={APP_PATHS.thankYou} element={<ThankYouPage />} />

        {/* Auth Routes */}
        <Route path={APP_PATHS.login} element={<LoginPage />} />

        {/* Admin Routes (API key auth) */}
        <Route path={APP_PATHS.admin} element={<AdminOnboardingsPage />} />
        <Route path={APP_PATHS.adminUsers} element={<AdminUsersPage />} />
        <Route path={APP_PATHS.adminXUsers} element={<AdminXUsersPage />} />
        <Route path={APP_PATHS.adminCategories} element={<AdminCategoriesPage />} />

        {/* Protected Routes with Layout */}
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<DashboardPage />} />
          {/* Add more protected routes */}
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={HTTP_CONFIG.TOAST_AUTO_CLOSE_MS}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
    </>
  );
}
